import { useEffect, useState } from "react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

// Tendina di sola selezione da anagrafica (senza aggiunta rapida) — es. Istruttore.
export default function SubjectSelect({ atype, value, onChange, testId, placeholder, url }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(url || `/anagrafiche/${atype}`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [atype, url]);

  const norm = url
    ? (s) => (s || "").toLowerCase().split(/\s+/).filter(Boolean).sort().join(" ")
    : (s) => s || "";
  const seen = new Set();
  const unique = url ? items.filter((r) => { const k = norm(displayName(r)); if (!k || seen.has(k)) return false; seen.add(k); return true; }) : items;
  const match = value ? unique.find((r) => norm(displayName(r)) === norm(value)) : null;
  const extra = value && !match ? [value] : [];
  const selected = match ? displayName(match) : value;

  return (
    <Select value={selected || "__none__"} onValueChange={(v) => onChange(v === "__none__" ? "" : v)}>
      <SelectTrigger data-testid={testId} className="mt-1.5 h-9 bg-slate-900/60 border-slate-700 text-slate-100 [&>svg]:opacity-100 [&>svg]:text-slate-100"><SelectValue placeholder={placeholder || "Seleziona"} /></SelectTrigger>
      <SelectContent className="bg-[#121824] border-slate-700 text-slate-100">
        <SelectItem value="__none__">Nessuno</SelectItem>
        {extra.map((n) => <SelectItem key={`x-${n}`} value={n}>{n}</SelectItem>)}
        {unique.map((r) => { const n = displayName(r); return <SelectItem key={r.id} value={n}>{n}</SelectItem>; })}
      </SelectContent>
    </Select>
  );
}
